import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ngxLoadingAnimationTypes } from 'ngx-loading';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  // Track concurrent operations to prevent premature loader hiding
  private loadingOperations = new Set<string>();

  public loadingConfig = {
    animationType: ngxLoadingAnimationTypes.cubeGrid,
    primaryColour: '#FFFFFF',           // White color for cube animation for high contrast
    secondaryColour: '#687870',         // Muted gray-green for secondary color
    backdropBackgroundColour: 'rgba(0,0,0,0.5)', // Darker, semi-transparent backdrop
    backdropBorderRadius: '8px',        // Rounded edges for a softer look
    fullScreenBackdrop: true,           // Full-screen loader
  };

  /**
   * Show loader with optional operation ID for tracking concurrent operations
   * @param operationId Unique identifier for this operation (default: 'default')
   */
  show(operationId: string = 'default'): void {
    this.loadingOperations.add(operationId);
    this.updateLoadingState();
  }

  /**
   * Hide loader for specific operation ID
   * @param operationId Unique identifier for this operation (default: 'default')
   */
  hide(operationId: string = 'default'): void {
    this.loadingOperations.delete(operationId);
    this.updateLoadingState();
  }

  /**
   * Update loading state based on active operations count
   */
  private updateLoadingState(): void {
    this.loadingSubject.next(this.loadingOperations.size > 0);
  }

  /**
   * Get list of currently active operation IDs (for debugging)
   * @returns Array of active operation IDs
   */
  getActiveOperations(): string[] {
    return Array.from(this.loadingOperations);
  }
}
